/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
export const userAuthenticationTranslations: any = {
  "en-GB": {
    "login" : {
      "login" : "Login",
      "logout" : "Logout",
      "username": "Username",
      "password" : "Password",
      "cancel": "Cancel",
      "submit": "Submit"
    }
  },
  "de-DE": {
    "login" : {
      "login" : "Einloggen",
      "logout" : "Ausloggen",
      "username": "Benutzername",
      "password" : "Passwort",
      "cancel": "Abbrechen",
      "submit": "Übernehmen"
    }
  }
};